/**
 * Safely retrieves a query parameter from a URLSearchParams object.
 * Returns an empty string if the parameter is null, "null", or undefined.
 *
 * @param {URLSearchParams} queryParams - The URLSearchParams object to get the parameter from
 * @param {string} param - The name of the parameter to retrieve
 * @return {string} The parameter value or empty string
 */
export const safeGetParam = (
  queryParams: URLSearchParams,
  param: string
): string => {
  const rawValue = queryParams
    .toString()
    .split("&")
    .find((p) => p.startsWith(`${param}=`))
    ?.split("=")[1];

  return rawValue ? decodeURIComponent(rawValue) : "";
};
